import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { TYPOGRAPHY_19, TYPOGRAPHY_21, TYPOGRAPHY_15 } from 'theme/theme'
import Form from 'components/forms/form'
import Label from 'components/typeForms'
import { inputNumber2 } from 'utils/numbers'
import ErrorText from 'components/forms/errorMsg'
const Autocomplete = dynamic(() => import('components/typeForms/autocomplete'), { ssr: false })
const Input = dynamic(() => import('components/typeForms/input'), { ssr: false })
const Submit = dynamic(() => import('components/buttons/submit'), { ssr: false })

export const ActionsWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  align-items: center;

  @media (max-width: 991px) {
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
  }
`

export const SeriesBButton = styled.div`
  width: 171px;
  height: 34px;
  background: #0bf;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  cursor: pointer;
`

export const SeriesText = styled.div`
  ${TYPOGRAPHY_19}

  color: #fff;
`

const ProgressWrap = styled.div`
  position: absolute;
  right: 80px;
  bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 991px) {
    position: unset;
    margin-top: 80px;
  }
`

const ProgressText = styled.div`
  ${TYPOGRAPHY_21}

  color: ${props => props.active ? '#00D6BD' : '#A0A5B3'}
`

export function SeriesQuestion ({ setAnswer, name, label, no, formik }) {
  const onClick = async (ans) => {
    setAnswer(ans)
    await formik.submitForm()
  }

  return (
    <>
      <Label id={name} label={label} no={no} />
      <SeriesBButton onClick={() => onClick(true)} name={name}>
        <SeriesText>Yes</SeriesText>
      </SeriesBButton>
      <SeriesBButton onClick={() => onClick(false)}>
        <SeriesText>No</SeriesText>
      </SeriesBButton>
    </>
  )
}

SeriesQuestion.propTypes = {
  setAnswer: PropTypes.func,
  name: PropTypes.string,
  formik: PropTypes.object,
  label: PropTypes.string,
  no: PropTypes.number
}

export function TextInput ({ formik, s, QUESTIONS }) {
  const keys = Object.keys(QUESTIONS)

  const onChange = (e) => {
    e.target.value = inputNumber2(e)
    formik.handleChange(QUESTIONS[s].name)(e)
  }

  return (
    <Form onSubmit={formik.handleSubmit} autoComplete="off">
      { !!keys && keys.map((key, i) => {
        if (key === `${s}`) {
          const q = QUESTIONS[key]

          return (
            <Input
              key={i}
              name={q.name}
              label={q.q}
              type={q.type === 'number' ? 'text' : q.type}
              no={s + 1}
              autoComplete="new-password"
              onChange={(e) => q.type === 'number'
                ? onChange(e)
                : formik.handleChange(q.name)(e)}
              onBlur={formik.handleBlur}
              value={formik.values[q.name]}
              errors={formik.errors[q.name]}
              disabled={formik.isSubmitting} />
          )
        } else return null
      })}

      { QUESTIONS[s] && QUESTIONS[s].sub ? <Sub>{ QUESTIONS[s].sub }</Sub> : null }
      <ActionsWrapper>
        <Submit name="OK" loading={formik.isSubmitting} />
      </ActionsWrapper>
    </Form>
  )
}

TextInput.propTypes = {
  formik: PropTypes.any,
  QUESTIONS: PropTypes.object,
  s: PropTypes.number
}

export function Company ({ companyName, setInput, s, input, setCompanyName, formik, QUESTIONS, err }) {
  return (
    <Form onSubmit={formik.handleSubmit}>
      <Autocomplete
        label={QUESTIONS[s].q}
        no={s + 1}
        name="companyName"
        type="text"
        value={companyName?.name}
        setInput={setInput}
        input={input}
        formik={formik}
        onFinal={setCompanyName}
        showValue />
      { err ? <ErrorText>{ err }</ErrorText> : null }
      <ActionsWrapper>
        <Submit name="OK" loading={formik.isSubmitting} />
      </ActionsWrapper>
    </Form>
  )
}

Company.propTypes = {
  companyName: PropTypes.object,
  setInput: PropTypes.func,
  input: PropTypes.string,
  formik: PropTypes.object,
  setCompanyName: PropTypes.func,
  QUESTIONS: PropTypes.object,
  err: PropTypes.string,
  s: PropTypes.number
}

export function ProgressComponent ({ s, steps }) {
  return (
    <ProgressWrap>
      <div className="flex mb-12">
        <ProgressText className="mr-5" active>{ s + 1 }</ProgressText>
        <ProgressText>{ `/ ${steps}` }</ProgressText>
      </div>
      <progress max="100" value={100 / steps * (s + 1)} />
    </ProgressWrap>
  )
}

ProgressComponent.propTypes = {
  steps: PropTypes.number,
  s: PropTypes.number
}

export const Sub = styled.div`
  ${TYPOGRAPHY_15}

  color: #505259;
  margin-top: -10px;
  margin-bottom: -20px;
`
